import { Tokens } from "@accurx/design";
import styled from "styled-components";

export const StyledHeaderContainer = styled.div`
    width: 100%;
    max-width: ${Tokens.BREAKPOINTS.md};
`;
